import api from "@/lib/axios";

export const getChannels = async () => {
  const { data } = await api.get("/channels");
  return data.data;
};

export const getConnections = async () => {
  const { data } = await api.get("/connections");
  return data.data;
};

export const createConnection = async (payload) => {
  const { data } = await api.post("/connections", payload);
  return data.data;
};

export const updateConnection = async (id, payload) => {
  const { data } = await api.patch(`/connections/${id}`, payload);
  return data.data;
};

export const deleteConnection = async (id) => {
  const { data } = await api.delete(`/connections/${id}`);
  return data.data;
};

export const testConnection = async (id) => {
  const { data } = await api.post(`/connections/${id}/test`);
  return data.data; // { ok, error? }
};

export const getMappings = async (connectionId) => {
  const { data } = await api.get(`/connections/${connectionId}/mappings`);
  return data.data;
};

export const upsertMapping = async (connectionId, productId, payload) => {
  const { data } = await api.put(
    `/connections/${connectionId}/mappings/${productId}`,
    payload,
  );
  return data.data;
};

export const deleteMapping = async (connectionId, productId) => {
  const { data } = await api.delete(
    `/connections/${connectionId}/mappings/${productId}`,
  );
  return data.data;
};

// Activate/deactivate the product on the channel itself (only supportsSetActive channels).
export const setMappingActive = async (connectionId, productId, isActive) => {
  const { data } = await api.put(
    `/connections/${connectionId}/mappings/${productId}/active`,
    { isActive },
  );
  return data.data;
};

// The channel's own product groups (e.g. Dinosoft GroupName) for the exclusion picker.
export const getConnectionGroups = async (connectionId) => {
  const { data } = await api.get(`/connections/${connectionId}/groups`);
  return data.data;
};

export const getRemoteProducts = async (connectionId, reload = false) => {
  const { data } = await api.get(
    `/connections/${connectionId}/remote-products?reload=${reload}`,
  );
  return data.data;
};

export const getAutoMatchSuggestions = async (connectionId, reload = false) => {
  const { data } = await api.get(
    `/connections/${connectionId}/auto-match?reload=${reload}`,
  );
  return data.data;
};

export const confirmAutoMatch = async (connectionId, matches) => {
  const { data } = await api.post(`/connections/${connectionId}/auto-match`, {
    matches,
  });
  return data.data;
};

export const syncPrices = async (connectionId) => {
  const { data } = await api.post(`/connections/${connectionId}/sync-prices`);
  return data.data; // { pushed, skipped, filtered, noPrice, missingRemoteIds }
};

// Tüm aktif kanalları tek istekte senkronize eder (tek özet mail atar). branchId verilirse
// yalnızca o şubenin aktif kanalları gönderilir.
export const syncAllPrices = async (branchId = null) => {
  const { data } = await api.post("/connections/sync-all", null, {
    params: branchId ? { branchId } : undefined,
  });
  return data.data; // { count, pushed, failedConnections, rejectedProducts }
};

export const syncRemote = async (connectionId) => {
  const { data } = await api.post(`/connections/${connectionId}/sync-remote`);
  return data.data; // { updated, cleared }
};
